import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import "hammerjs";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { TranslateModule } from "@ngx-translate/core";
import { ContextMenuModule } from "@ctrl/ngx-rightclick";

import { CoreModule } from "@core/core.module";
import { CoreCommonModule } from "@core/common.module";
import { CoreSidebarModule, CoreThemeCustomizerModule } from "@core/components";
import { CardSnippetModule } from "@core/components/card-snippet/card-snippet.module";

import { coreConfig } from "app/app-config";
import { JwtInterceptor, ErrorInterceptor } from "app/auth/helpers";
import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { ContentHeaderModule } from "app/layout/components/content-header/content-header.module";
import { MiscellaneousModule } from "./main/miscellaneous/miscellaneous.module";
import { HttpLinkModule, HttpLink } from "apollo-angular-link-http";
import { CreateApollo } from "./services/apollo/apollo";
import { ApolloModule, APOLLO_OPTIONS } from "apollo-angular";
import { CustomToastrComponent } from "./menu/custom-toastr/custom-toastr.component";
import { TenantInterceptor } from "./auth/interceptors/tenant.interceptor";
import { ApiTrackingInterceptor } from "./auth/interceptors/tracking.interceptor";
import { JWT_OPTIONS, JwtHelperService } from "@auth0/angular-jwt";
import { SmartAppBannerComponent } from "./layout/components/smart-app-banner/smart-app-banner.component";

import { LOCALE_ID } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { ShepherdService } from "angular-shepherd";

registerLocaleData(localeFr);

const appRoutes: Routes = [
  {
    path: "utrav",
    loadChildren: () => import("./main/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "authentication",
    loadChildren: () =>
      import("./main/authentication/authentication.module").then((m) => m.AuthenticationModule),
  },
  {
    path: "",
    redirectTo: "/utrav/home/statistics",
    pathMatch: "full",
  },
  {
    path: "**",
    redirectTo: "/miscellaneous/error",
  },
];

@NgModule({
  declarations: [AppComponent, CustomToastrComponent, SmartAppBannerComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: "enabled",
      relativeLinkResolution: "legacy",
    }),
    NgbModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot(),
    ContextMenuModule,
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,
    CardSnippetModule,
    LayoutModule,
    ContentHeaderModule,
    MiscellaneousModule,
    HttpLinkModule,
    ApolloModule,
  ],
  providers: [
    ShepherdService,
    { provide: LOCALE_ID, useValue: "fr-FR" },
    JwtHelperService,
    {
      provide: JWT_OPTIONS,
      useValue: JWT_OPTIONS,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ApiTrackingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TenantInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: APOLLO_OPTIONS,
      useFactory: (httpLink: HttpLink) => {
        const { link, cache } = CreateApollo();
        return {
          cache,
          link,
        };
      },
      deps: [HttpLink],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
